import type { Item } from '@/modules/main/carrier/add/components/components/Chassis';
import type { FieldsetPassThroughOptions } from 'primereact/fieldset';

interface Door {
  name: number | string;
  id: number;
}
export const doorOptions: Door[] = [
  { name: 1, id: 1 },
  { name: 2, id: 2 },
  { name: 3, id: 3 },
  { name: 4, id: 4 },
  { name: 5, id: 5 },
];

export const doorOptionsMore: Door[] = [
  { name: 6, id: 1 },
  { name: 7, id: 2 },
  { name: 8, id: 3 },
  { name: 9, id: 4 },
];

export const tractionOptions = [
  { name: 'NA', id: 0 },
  { name: '2WD', id: 1 },
  { name: '4WD', id: 2 },
  { name: 'AWD', id: 3 },
];

export const seatingCapacity = [
  { name: 1, id: 1 },
  { name: 2, id: 2 },
  { name: 3, id: 3 },
  { name: 4, id: 4 },
  { name: 5, id: 5 },
  { name: 6, id: 6 },
  { name: 7, id: 7 },
  { name: 8, id: 8 },
  { name: 9, id: 9 },
];

export const keyOptions = [
  { name: 'smart key', value: 'smartKey' },
  { name: 'keyless', value: 'keyless' },
  { name: 'original', value: 'original' },
  { name: 'steel', value: 'steel' },
];

export const history_of_use = [
  { name: 'Used', id: 1 },
  { name: 'New', id: 2 },
];

export const drive_way_items: Item[] = [
  { name: 'RHD', value: 'RHD' },
  { name: 'LHD', value: 'LHD' },
];
export const fieldsetPt: FieldsetPassThroughOptions = {
  root: {
    style: {
      borderColor: 'var(--surface-400)',
    },
  },
  content: {
    className: 'flex flex-col gap-20',
  },
  legend: {
    className:
      'bg-surface-200 dark:bg-surface-600 text-surface-800 dark:text-surface-50',
    style: {
      borderColor: 'var(--surface-400)',
    },
  },
};
export const statusColors = {
  Draft: 'bg-slate-500',
  'Rikso requested': 'bg-blue-500',
  'Rikso completed': 'bg-indigo-500',
  'Ready to sale': 'bg-emerald-500',
  'Inspection requested': 'bg-amber-400',
  'Inspection completed': 'bg-orange-500',
  Booked: 'bg-purple-500',
  'Ready to ship': 'bg-cyan-500',
  'Shipment booked': 'bg-sky-400',
  Shipped: 'bg-violet-300',
  'Documents requested': 'bg-pink-500',
  'Ready to deliver': 'bg-teal-700',
  Delivered: 'bg-green-600',
  Cancelled: 'bg-rose-600',
} as const;

export const carrierTypeColors = {
  Vehicle: 'bg-blue-500',
  Machine: 'bg-green-500',
  Attachment: 'bg-orange-500',
  Part: 'bg-gray-700',
} as const;

export const statusColorCodes = {
  proposal: 'bg-blue-400',
  'sale closed': 'bg-green-400',
  invoiced: 'bg-purple-400',
  booked: 'bg-teal-400',
  cancelled: 'bg-red-400',
  'final invoiced': 'bg-indigo-400',
  'waiting for payment': 'bg-yellow-400',
  closed: 'bg-green-400',
  'not booked': 'bg-gray-400',
};
export const viewCarrierStructure = {
  basicCost: {
    section1: {
      part1: {
        stock: 'stock',
        make: 'make',
        model: 'model',
        modelCode: 'model_code',
        chModel: 'ch_model',
        chNo: 'ch_no',
        fuelType: 'fuel_type',
        category: 'category',
        exportCategory: 'export_cat',
        engineYearMonth: 'engine_ym',
      },
      part2: {
        transmission: 'transmission',
        traction: 'traction',
        drive: 'drive',
        powerKw: 'power_kw',
        powerCc: 'power_cc',
        doors: 'doors',
        capacity: 'capacity',
        seating: 'seating',
        extColor: 'ext_colour',
        interiorColour: 'int_colour',
        condition: 'condition',
        engineType: 'engine_type',
        engineNo: 'engine_no',
        driveKM: 'drive_km',
        ichijiMacho: 'ich_mash',
      },
      part3: {
        dealer: 'dealer',
        seller: 'seller',
        auctionBy: 'auction_by',
        purchasedDate: 'purchased_dt',
        auctionDate: 'auc_date',
        lotNo: 'lot_no',
        runNo: 'run_no',
        bidder: 'bidder',
        location: 'location',
        salesPerson: 'sales_person',
        auctionGrade: 'auc_grade',
      },
    },
    section2: {
      fobPrice: 'fob_price',
      totalCost: 'total_cost',
      salePercent: 'sale_percent',
      saleResult: 'sale_result',
      saleAmt: 'sale_amt',
      basicCost: {
        buyPrice: 'buy_price',
        aucFee: 'auc_fee',
        riksoFee: 'rikso_fee',
        inspectionFee: 'inspection_fee',
        buyPriceTax: 'buy_price_tax',
        aucFeeTax: 'auc_fee_tax',
        riksoFeeTax: 'rikso_fee_tax',
        inspectionFeeTax: 'inspection_fee_tax',
        jidoushaZei: 'jidousha_zei',
        recycleFee: 'recycle_fee',
      },
      saleCost: {
        aucListFee: 'auc_list_fee',
        portRemovalFee: 'port_removal_fee',
        forwardingCost: 'forwarding_cost',
        radioActive: 'radio_active',
        storageFee: 'storage_fee',
        aucSellingFee: 'auc_selling_fee',
        freightFee: 'freight_fee',
        insuranceFee: 'insurance_fee',
      },
      creditCost: {
        recyleFeeRefund: 'recyle_fee_refund',
        jidoushaZeinRefund: 'jidousha_zei_refund',
        claimCredit: 'claim_credit',
        lateDocCredit: 'late_doc_credit',
        discCredit: 'disc_credit',
      },
      additionalCost: {
        shaken: 'shaken',
        shakenReceived: 'shaken_received',
        claimCost: 'claim_cost',
        portRemovalFee: 'port_removal_fee',
        parkingPenalty: 'parking_penalty',
        misc: 'misc',
      },
    },
  },
  moreInfo: {
    goods: {
      received: 'recd',
      description: 'desc',
      action: 'action',
      done: 'done',
      courier: 'courier',
      awb: 'awb_no',
      putInStock: 'stock',
    },
    bodyDimensions: {
      netWeight: 'net_wt',
      grossWeight: 'gross_wt',
      carryingWeight: 'carrying_wt',
      carHeight: 'car_height',
      carLength: 'car_length',
      carWidth: 'car_width',
      carArea: 'car_area',
      n1: 'n1',
      n2: 'n2',
      n3: 'n3',
      n4: 'n4',
    },
    properties: {
      ac: 'f_ac',
      powerSteering: 'f_power_steering',
      abs: 'f_abs',
      srsAirbags: 'f_srs',
      powerWindows: 'f_power_window',
      rearSpoiler: 'f_r_spoiler',
      roofRail: 'f_roof_rail',
      tv: 'f_tv',
      navigation: 'f_navigation',
      autoWindow: 'f_auto_window',
      leatherSeats: 'f_leather_seats',
      bluetooth: 'f_bluetooth',
      sunRoof: 'f_sun_roof',
      fogLights: 'f_fog_lights',
      bodyKit: 'f_body_kit',
      cornerSensor: 'f_corner_sensor',
      oneOwner: 'f_one_owner',
      powerSlideDoor: 'f_power_slide_door',
      centralLock: 'f_central_lock',
      powerMirror: 'f_power_mirror',
      powerSeats: 'f_power_seats',
      backCam: 'f_back_cam',
      camera360: 'f_camera_360',
      panoramaRoof: 'f_panorama_roof',
      led: 'p_led',
      displayAudio: 'p_display_audio',
      oneSidePowerSlideDoor: 'p_one_side_power_slide_door',
      bothSidePowerSlideDoor: 'p_both_side_power_slide_door',
    },
  },
  bookingInfo: {},
  riksoInspection: {},
  documents: {},
} as const;

export const classifyFuelType = [
  {
    id: 1,
    name: 'Biodiesel',
    type: 'power',
  },
  {
    id: 2,
    name: 'CNG',
    type: 'power',
  },
  {
    id: 3,
    name: 'Diesel',
    type: 'power',
  },
  {
    id: 4,
    name: 'Electric',
    type: 'energy',
  },
  {
    id: 5,
    name: 'Ethanol-FFV',
    type: 'power',
  },
  {
    id: 6,
    name: 'Gasoline/Petrol',
    type: 'power',
  },
  {
    id: 7,
    name: 'Hybrid-electric',
    type: 'energy',
  },
  {
    id: 8,
    name: 'Hydrogen',
    type: 'power',
  },
  {
    id: 9,
    name: 'LPG',
    type: 'power',
  },
  {
    id: 10,
    name: 'Steam',
    type: 'power',
  },
  {
    id: 11,
    name: 'Others',
    type: 'power',
  },
] as const;

export const priceFieldsSchema: [string, number, number, string, string][] = [
  [
    'buying_price',
    10, // min 2 digits
    99999999999999, // max 14 digits
    'error.buyingPrice.min',
    'error.buyingPrice.max',
  ],
  [
    'buying_price_tax',
    1, // min 1 digits
    999999999999, // max 12 digits
    'error.buyingPriceTax.min',
    'error.buyingPriceTax.max',
  ],
  [
    'auction_fee',
    10, // min 2 digits
    9999999999, // max 10 digits
    'error.auctionFee.min',
    'error.auctionFee.max',
  ],
  [
    'auction_fee_tax',
    1, // min 1 digits
    99999999, // max 8 digits
    'error.auctionFeeTax.min',
    'error.auctionFeeTax.max',
  ],
] as const;

export const imageModifyActions = [
  'make_cover_img',
  'make_cover_img',
  'make_public_visible',
  'make_visibly_private',
  'remove_image',
] as const;

export const documentCategories = {
  carrier: 'bg-slate-600',
  inspection: 'bg-purple-700',
  shipping: 'bg-green-600',
  transport: 'bg-orange-600',
};

export const docTypeColors = {
  de_reg_certificate: 'bg-slate-400',
  export_certificate: 'bg-purple-700',
  registration_certificate: 'bg-green-600',
  road_tax_certificate: 'bg-orange-600',
  letter_of_credit: 'bg-red-700',
  others: 'bg-gray-400',
};

export const docTypeMap = {
  'De-Registration Certificate': 'de_reg_certificate',
  'Export Certificate': 'export_certificate',
  'Registration Certificate': 'registration_certificate',
  'Road Tax Certificate': 'road_tax_certificate',
  'Letter of Credit': 'letter_of_credit',
  Others: 'others',
} as const;
